// External libraries
import React from 'react';
import { LoadingElement } from '@checkout/react-components';

// Internal modules
import { lazyLoader } from '@/lib';
import { KYCFields } from './KYCFields';

const LazyKYCFields = lazyLoader({
  loader: () => import('./KYCFields'),
  loading: () => <LoadingElement />,
  name: 'kyc_inputs',
  render(loaded, props) {
    return <KYCFields {...props} />;
  },
});

export { LazyKYCFields };
